import axios from "axios";
import {message} from "ant-design-vue";
import {ref} from "vue";

export default {
  async clearBlockData(block) {
    if (block.type === 'ImageRender') {
      this.deleteImage(block);
    }
  },
  async deleteImage(block, competitionId) {
    const deletePath = '/competition/delete_competition_image';
    try {
      if (block.value && block.value !== '') {
        await axios.post(deletePath, {
          image_name: block.value,
          competitionId: competitionId
        });
        message.success('Изображение успешно удалено');
      }
    } catch (error) {
      console.error('Ошибка при удалении изображения:', error);
      message.error('Произошла ошибка при удалении изображения');
    }
  }
}